import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex-grow flex flex-col items-center" }

import NavigationHeader from "@/parts/NavigationHeader.vue";
import NavigationFooter from "@/parts/NavigationFooter.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavigationHeader, { class: "w-full" }),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view, { class: "flex-grow" })
    ]),
    _createVNode(NavigationFooter)
  ]))
}
}

})